import * as React from "react";
import "./main.css";
import Feed from "../components/Feed/feed";
import DCard from "../components/DCard/DCard";
import { Helmet } from "react-helmet";






const IndexPage = () => {


  return (
    <div>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0"/>
        <meta name="description" content="Mary's portfolio landing page"/>
        <link rel="icon" type="image/png" href="../images/berta.png" sizes="16x16" />
      </Helmet>
      <main>
        <section className="draggable" id="sticky">
          <div className="note">
            <div className="note-heading"> Welcome! </div>
            <div className="note-body">
              <br></br>
              Learning in progress... Sharing updates on the phone. Previous design projects are backed up in the "Projects" drive. 
            </div>
          </div>

          <div className="card">
          <DCard/>
          </div>
        </section>
        <section className="draggable" id="drive">
          <a target="_blank" href="https://merryj.notion.site/Projects-9b2ef32113db44169f5df008bf7f897f">
            <div className="usb">
              <div className="usb-body">
                <div className="usb-body-label">PROJECTS</div>
              </div>
              <div className="usb-head">
                <div className="usb-head-connector"></div>
              </div>
            </div>
          </a>

         
        </section>
        <section id="phone">
          <div className="phone-screen">
            <div className="screen-content">
              <Feed></Feed>
            </div>
          </div>
        </section>

        
      </main>
    </div>
  );
};

export default IndexPage;
